//@ts-check
import React from 'react';
import Text from './Text';

var PasswordField = function PasswordField(props) {
  return React.createElement(Text, props);
};

PasswordField.defaultProps = {
  type: 'password'
};
export default PasswordField;